export default {
  init() {

    // $('[data-toggle="collapse"]').click(function() {
    //   $('.collapse.in').collapse('hide')
    // });
    
   jQuery(document).ready(function($){

      $('.user-content iframe').each(function() {
        $(this).wrap('<div class="embed-responsive embed-responsive-16by9" />');
      });

	    $(".site-header-mobile--menu-button .open-menu").click(function() {
	    	$(".site-header-mobile--menu-button .open-menu").toggleClass("open");
	    	$(".site-header--nav").toggleClass("show");
	    });

      $(document).on('click', '[data-search]', function() {
        $('.se-search__input').focus()
      });

      $('.gallery').each(function() {
        $(this).magnificPopup({
          delegate: 'a',
          type: 'image',
          gallery: {
            enabled:true,
          },
        });
      });
      
      /*
       * When clicking on certain elements we can add or remove
       * body classes in order to show or hide elements
       * accordingly
       */
       var $addRemoveClasses = (function() {

        var $adds = $('[data-add-class]'),
        $removes = $('[data-remove-class]'),

        init = function() {
          $(document).on('click', '[data-add-class]', function(e) {
            e.preventDefault();
            var $class = $(this).data('add-class');
            var $target = typeof $(this).data('add-to') !== 'undefined' ? $($(this).data('add-to')) : $('body');
            if( ! $target.hasClass($class) ) {
              $target.addClass($class);
            }
          });
          $(document).on('click', '[data-remove-class]', function(e) {
            e.preventDefault();
            var $class = $(this).data('remove-class');
            var $target = typeof $(this).data('remove-from') !== 'undefined' ? $($(this).data('remove-from')) : $('body');
            if( $target.hasClass($class) ) {
              $target.removeClass($class);
            }
          });
        };

        return {init: init};

      })();

      $addRemoveClasses.init();

      /*
      * Basic tab functionality
      */
      var $tabs = (function() {
        var $buttons = $('[data-st-tab]'),
        $tabs = $('[data-st-panel]'),
        $container = $('[data-st-tabs]'),

        showTab = function($button) {
          var $container = $button.closest('[data-st-tabs]');
          $container.find('[data-st-panel]').hide();
          $container.find('[data-st-tab]').removeClass('active');
          $button.addClass('active');
          var $target = $button.data('st-tab');
          $container.find('[data-st-panel="' + $target + '"]').fadeIn();
        },
        initEvents = function() {
          $buttons.on('click', function(e) {
            e.preventDefault();
            showTab($(this));
          });
        },
        init = function() {
          initEvents();
          $container.each(function() {
            var $selected = $(this).find('[data-st-tab][data-st-selected]');
            if( $selected.length > 0 ) {
              showTab($selected.first());
            } else {
              showTab($(this).find($buttons).first());
            }
          });
        };
        return {init: init};
      })();

      $tabs.init();

	 });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js